var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.1C22.6 6.1 23.5 5.2 23.5 4.1V2C23.5 0.9 22.6 0 21.5 0C20.4 0 19.5 0.9 19.5 2V4.1C19.5 5.2 20.4 6.1 21.5 6.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 3.49999H24.6V4.49999C24.6 6.19999 23.2 7.59999 21.5 7.59999C19.8 7.59999 18.4 6.19999 18.4 4.49999V3.49999H10.2V4.49999C10.2 6.19999 8.8 7.59999 7.1 7.59999C5.4 7.59999 4.1 6.19999 4.1 4.49999V3.49999L0 3.39999V29.1H2.1H26.7H28.7V3.49999ZM26.7 27.1H2.1V10.7H26.7V27.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1001 6.1C8.2001 6.1 9.1001 5.2 9.1001 4.1V2C9.1001 0.9 8.2001 0 7.1001 0C6.0001 0 5.1001 0.9 5.1001 2V4.1C5.1001 5.2 6.0001 6.1 7.1001 6.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17.6H20.3V20.5H23.5V17.6Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.8f4636a2.svg";
export { ForwardRef as ReactComponent };